import React from 'react'

import { formatCurrency } from 'utils/formatters'
import Button from 'common/Button'
import Card from 'common/Card'
import ReactTable from 'common/ReactTable'

import OverbillAttachments from './OverbillAttachment'
export default ({
  caseNumber,
  caseSubject,
  caseCurrency,
  overbill,
  handleOnApprove,
  handleOnReject,
  approved,
  rejected,
  resource,
}) => {
  const { lines: overbillLines = [], piAttachments = [], remarks, totalTaxExcl } = overbill
  const hideApprove = rejected || approved

  const columns = React.useMemo(
    () => [
      {
        Header: resource.Description,
        accessor: 'description',
      },
      {
        Header: resource.Quantity,
        accessor: 'quantity',
      },
      {
        Header: resource.Unit,
        accessor: 'unit',
      },
      {
        Header: resource.SupplierPrice,
        accessor: 'supplierPrice',
        Cell: ({ value }) => (value ? formatCurrency(value, undefined, caseCurrency.currencySymbol) : '-'),
      },
      {
        Header: resource.OverbillAmount,
        accessor: 'amount',
        Cell: ({ value }) => (value ? formatCurrency(value, undefined, caseCurrency.currencySymbol) : '-'),
        Footer: totalTaxExcl ? formatCurrency(totalTaxExcl, undefined, caseCurrency.currencySymbol) : '-',
      }
    ],
    [caseCurrency.currencySymbol]
  )

  return (
    <Card
      title={
        <div className="d-flex flex-wrap">
          <div>{caseNumber}</div>
          <div>
            <div className="vr" style={{ marginLeft: 10, marginRight: 10 }}></div>
          </div>
          <div>{caseSubject}</div>
        </div>
      }
      color="primary"
      outline
      className="mb-4"
      bodyClassName="col-lg-12"
      footer={
        <div>
          {!hideApprove && (
            <Button icon="done" color="success" className="float-end" onClick={handleOnApprove}>
              {resource.Approve}
            </Button>
          )}
          {!approved && (
            <Button icon="cancel" color="danger" className="float-start" onClick={handleOnReject}>
              {resource.Reject}
            </Button>
          )}
        </div>
      }
    >
      <Card
        title={
          <div className="col-lg-12">
            {resource.OverbillInvoice} #{overbill.documentIndex} - {overbill.invoiceReference}
          </div>
        }
        outline
        className="mb-4"
        bodyClassName="col-lg-12"
      >
        <ReactTable columns={columns} data={overbillLines} showFooter responsive />
        <OverbillAttachments piAttachments={piAttachments} resource={resource} />
        <div className="row">
          <div className="col-lg-3">
            <b>{resource.Remarks}:</b>
          </div>
          <div className="col-lg-9">{remarks}</div>
        </div>
      </Card>
    </Card>
  )
}
